import kebabCase from 'lodash/kebabCase';
import { CSSProperties } from 'react';

/**
 * Converts theme values into CSS custom properties, so a stylesheet can use
 * them in `:hover`, `:focus` and media-free rules instead of inline styles.
 *
 * @param {Record<string, string | number>} values - camelCase in, kebab-case out
 * @returns {CSSProperties}
 */
export const toCssVariables = (
  values: Record<string, string | number>,
): CSSProperties =>
  Object.fromEntries(
    Object.entries(values).map(([name, value]): [string, string | number] => [
      `--${kebabCase(name)}`,
      value,
    ]),
  ) as CSSProperties;
